/*
* Copyright (C) Regione Lombardia
*/
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '@shared/shared.module';
import { PagesGestioneRilievoCreaRilievoComponent } from './crea-rilievo/crea-rilievo.component';
import { PagesGestioneRilievoDettaglioRilievoComponent } from './dettaglio-rilievo/dettaglio-rilievo.component';
import { PagesGestioneRilievoRoutingModule } from './gestione-rilievo.routing';
import { PagesGestioneRilievoModificaRilievoComponent } from './modifica-rilievo/modifica-rilievo.component';
import { PagesGestioneRilievoRicercaRilievoComponent } from './ricerca-rilievo/ricerca-rilievo.component';
import { PagesGestioneRilievoToolkitModule } from './_toolkit/toolkit.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        NgbModule,
        SharedModule,
        PagesGestioneRilievoRoutingModule,
        PagesGestioneRilievoToolkitModule
    ],
    declarations: [
        PagesGestioneRilievoCreaRilievoComponent,
        PagesGestioneRilievoDettaglioRilievoComponent,
        PagesGestioneRilievoModificaRilievoComponent,
        PagesGestioneRilievoRicercaRilievoComponent,
    ],
    exports: [
        PagesGestioneRilievoCreaRilievoComponent,
        PagesGestioneRilievoDettaglioRilievoComponent,
        PagesGestioneRilievoModificaRilievoComponent,
        PagesGestioneRilievoRicercaRilievoComponent
    ],
})
export class PagesGestioneRilievoModule { }
